import React from 'react'

export default function CommonButton({
  children,
  onClick,
  color,
  backgroundColor,
  alignSelf,
  height,
  fontWeight,
  fontSize,
}) {
  return (
    <button
      style={{
        alignSelf: alignSelf || 'flex-start',
        color: color,
        height: height || '40px',
        backgroundColor: backgroundColor,
        padding: '8px',
        borderRadius: '50px',
        borderWidth: '1px',
        borderColor: color,
        borderStyle: 'solid',
        cursor: 'pointer',
        marginBottom: '10px',
      }}
      onClick={onClick}
    >
      <p
        style={{
          alignSelf: 'center',
          margin: 'auto',
          fontWeight: fontWeight || '500',
          fontSize: fontSize || '20px',
          padding: '0 10px',
          color: color,
          backgroundColor: backgroundColor,
        }}
      >
        {children}
      </p>
    </button>
  )
}
